<template>
  <div style="max-width:1200px;  margin: auto;" class="pa-3">
    <v-form ref="formSin" v-model="formRepresentante" lazy-validation @submit.prevent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.nombrePropietarioEmpresa"
            label="Nombre del Representante Legal de la Empresa" rows="1" :disabled="true" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.numeroCiPropietarioEmpresa"
            label="Cedula de Identidad del Representante Legal" rows="1" :disabled="true" />
        </v-flex>
      </v-layout>
    </v-form>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import types from '@/store/types/SolicitudCredenciales'

export default {
  data() {
    return {
      formRepresentante: false,
    }
  },
  methods: {
    ...mapMutations({
      SetDatosGuardados: types.mutations.SetDatosGuardados,
    }),
  },
  computed: {
    ...mapGetters({
      GetDatosGuardados: types.getters.GetDatosGuardados,
    }),
  }
}
</script>